'use strict'

import Vue from 'vue'

const namespaced = true

const state = {
  baseConnTime: 20 * 60 * 1000, // 30 * 60 millisecond
  reqAtmId: '',
  reqNormalAtmId: '',
  resAtmInfo: {},
  resNormalAtmInfo:{},
  resultAtmInfoId:'',
  timeoutId: '',
  apiUrl: '/api/purchase/atm/wsNotice',
  errMsg: {
    1: '권한이 없습니다.',
    2: '다른 기사가 작업 중 입니다.',
    3: 'ATM 문을 닫고 종료 해주세요'
  },
  atmCollectStep: 1,
  jobStartDateTime: '',
  doorOpenDateTime: '',
  isAtmOpen: false,
  bosCollectCnt: 0,
  workCollectCnt: 0,
  tryCnt: 0
}

const getters = {
  getTimeoutId: state => state.timeoutId,
  getErrMsg: state => state.errMsg,
  getReqAtmId: state => state.reqAtmId,
  getReqNormalAtmId: state => state.reqNormalAtmId,
  getResAtmInfo: state => state.resAtmInfo,
  getResNormalAtmInfo: state => state.resNormalAtmInfo,
  getAtmCollectStep: state => state.atmCollectStep,
  getJobStartDateTime: state => state.jobStartDateTime,
  getDoorOpenDateTime: state => state.doorOpenDateTime,
  getIsAtmOpen: state => state.isAtmOpen,
  getBosCollectCnt: state => state.bosCollectCnt,
  getWorkCollectCnt: state => state.workCollectCnt,
  getResultAtmInfoId: state => state.resultAtmInfoId,
  getTryCnt: state => state.tryCnt
}

const mutations = {
  stateResetInit(state) {
  state.reqNormalAtmId = ''
  state.atmCollectStep = 1
  state.reqNormalAtmId = ''
  state.resNormalAtmInfo = {}
},
  setTimeoutId (state, payload) {
    state.timeoutId = payload
  },
  setReqAtmId (state, payload) {
    state.reqAtmId = payload
  },
  setReqNormalAtmId (state, payload) {
    state.reqNormalAtmId = payload
  },
  setResAtmInfo (state, payload) {
    state.resAtmInfo = payload
  },
  setResNormalAtmInfo (state, payload) {
    state.resNormalAtmInfo = payload
  },
  setAtmCollectStep (state, payload) {
    state.atmCollectStep = payload
  },
  setJobStartDateTime (state, payload) {
    state.jobStartDateTime = payload
  },
  setDoorOpenDateTime (state, payload) {
    state.doorOpenDateTime = payload
  },
  setIsDoorOpen (state, payload) {
    state.isAtmOpen = payload
  },
  setBosCollectCnt (state, payload) {
    state.bosCollectCnt = payload
  },
  setWorkCollectCnt (state, payload) {
    state.workCollectCnt = payload
  },
  setResultAtmInfoId (state, payload) {
    state.resultAtmInfoId = payload
  },
  setTryCnt (state, payload) {
    state.tryCnt = payload
  }
}

const formatDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

const stateInit = (commit) => {
  commit('setResAtmInfo', {})
  commit('setResNormalAtmInfo', {})
  commit('setReqAtmId', '')
  commit('setReqNormalAtmId', '')
  commit('setJobStartDateTime', '')
  commit('setDoorOpenDateTime', '')
  commit('setAtmCollectStep', 1)
  commit('setTryCnt', 0)
}

const beforeUnloadHandler = (event) => {
  event.returnValue = true
  // return '이 페이지를 벗어나면 김까꿍입니다.'
}

const actions = {
  async getDlvdInfo({ commit, state }) {
    const atmId = state.reqNormalAtmId || '';
    const isQr  = atmId.endsWith('QR_ID');
  
    
    const apiUrl = isQr
      ? `/api/purchase/atm/info/${atmId.replace('QR_ID','')}`
      : `/api/purchase/customerCare/atm/${atmId}`;
  
    try {
      const { data } = await Vue.httpClient.get(apiUrl);
      const { status, result } = data || {};
  
      
      if (status !== '200') {
        await window.$Alert.alert('통신 오류가 발생했습니다.');
        return stateInit(commit);
      }
  
      const atmInfo = isQr
        ? (result && result.atmInfo)           
        : (Array.isArray(result) ? result[0] : null); 
  
      if (!atmInfo) {
        await window.$Alert.alert('배송처 정보를 찾지 못했습니다.');
        return stateInit(commit);
      }
  
      if (atmInfo.sts === '1' && atmInfo.atm_sers_num == null) {
        commit('setResultAtmInfoId', atmInfo.atm_id);
        commit('setResNormalAtmInfo', atmInfo);
        commit('setAtmCollectStep', 3);
      } else {
        const msg = '해당 배송처는 일반회수를 할 수 없습니다.<br/>고객센터에 문의 바랍니다.';
        await window.$Alert.alert(msg);
        stateInit(commit);
      }
    } catch (e) {
      console.error(e);
      await window.$Alert.alert('예기치 못한 오류가 발생했습니다.');
      stateInit(commit);
    }
  },
  getAtmInfo ({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {
      const apiUrl = `/api/purchase/atm/info/${state.reqAtmId}`
      Vue.httpClient.get(apiUrl)
        .then(res => {
          const { data: { status, result } } = res
          if (status === '200') {
            const { atmInfo } = result
            if (atmInfo) {
              commit('setResAtmInfo', { ...atmInfo })
              commit('setAtmCollectStep', 2)
              dispatch('noticeToAtm', { jobDvsnCode: 'job_start' })
            } else {
              window.$Alert.alert('ATM 정보를 찾지 못했습니다.').then(() => {
                stateInit(commit)
              })
            }
          }
        })
    })
  },
  // getNormalAtmInfo ({ dispatch, commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     const apiUrl = `/api/purchase/atm/info/${state.reqNormalAtmId}`
  //     Vue.httpClient.get(apiUrl)
  //       .then(res => {
  //         const { data: { status, result } } = res
  //         if (status === '200') {
  //           const { atmInfo } = result
  //           if (atmInfo) {
  //             commit('setResNormalAtmInfo', { ...atmInfo })
  //             commit('setAtmCollectStep', 3)
  //           } else {
  //             window.$Alert.alert('배송처 정보를 찾지 못했습니다.').then(() => {
  //               stateInit(commit)
  //             })
  //           }
  //         }
  //       })
  //   })
  // },
  noticeToAtm ({ dispatch, commit, state }, params) {
    return new Promise((resolve, reject) => {
      const apiUrl = state.apiUrl
      Vue.httpClient.post(apiUrl, {
        atmId: state.resAtmInfo.atm_id,
        ...params
      })
        .then(res => {
          const { data: { status, result } } = res
          if (status === '200' && result === 200) {
            dispatch('jobEndFunc')
            if (params.jobDvsnCode === 'job_start') {
              const currentDate = new Date()
              formatDate(currentDate)
              window.addEventListener('beforeunload', beforeUnloadHandler)
              commit('setJobStartDateTime', formatDate(currentDate))
            } else if (params.jobDvsnCode === 'door_open') {
              const currentDate = new Date()
              formatDate(currentDate)
              commit('setIsDoorOpen', true)
              commit('setDoorOpenDateTime', formatDate(currentDate))
            }
          } else {
            window.$Alert.alert(state.errMsg[result]).then(() => {
              stateInit(commit)
            })
          }
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  jobEndNoticeToAtm ({ dispatch, commit, state }, isFromLogOut) {
    return new Promise((resolve, reject) => {
      const apiUrl = state.apiUrl
      const parameter = {
        atmId: state.resAtmInfo.atm_id,
        jobDvsnCode: 'job_end',
        tryCnt: state.tryCnt+1
      }
      state.tryCnt = state.tryCnt +1

      if (state.resAtmInfo.atm_id) {
        if (state.isAtmOpen && state.bosCollectCnt > state.workCollectCnt) {
          if (!isFromLogOut) {
            window.$Alert.alert('ATM 내 회수해야 할 단말이 남아있습니다.')
              .then(() => {
                Vue.httpClient.post(apiUrl, parameter)
                  .then(res => {
                    const { data: { status, result } } = res

                    if (status === '200' && result === 200) {
                      console.log('>>>> > noticeToAtm jobDvsnCode job_end')
                      stateInit(commit)
                      window.removeEventListener('beforeunload', beforeUnloadHandler)
                      console.log('ATM websocket 작업 종료')
                      commit('setIsDoorOpen', false)
                    } else {
						window.$Alert.alert(state.errMsg[result])
					}
                  })
              })
          } else {
            Vue.httpClient.post(apiUrl, parameter)
              .then(res => {
                const { data: { status, result } } = res
                if (status === '200' && result === 200) {
                  console.log('>>>> > noticeToAtm jobDvsnCode job_end')
                  stateInit(commit)
                  window.removeEventListener('beforeunload', beforeUnloadHandler)
                  console.log('ATM websocket 작업 종료')
                  commit('setIsDoorOpen', false)
                } else {
					window.$Alert.alert(state.errMsg[result])
				}
              })
          }
        } else {
          Vue.httpClient.post(apiUrl, parameter)
            .then(res => {
              const { data: { status, result } } = res
              if (status === '200' && result === 200) {
                console.log('>>>> > noticeToAtm jobDvsnCode job_end')
                stateInit(commit)
                window.removeEventListener('beforeunload', beforeUnloadHandler)
                console.log('ATM websocket 작업 종료')
                commit('setIsDoorOpen', false)
              } else {
					window.$Alert.alert(state.errMsg[result])
				}
            })
        }
      }
    })
  },
  jobEndFunc: ({ commit, dispatch, state }) => {
    clearTimeout(state.timeoutId)
    const timeoutId = setTimeout(() => {
      dispatch('jobEndNoticeToAtm')
    }, state.baseConnTime)
    commit('setTimeoutId', timeoutId)
  }
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/modules/AtmWsStore.js